import { Box, Container } from "@mui/material";
import React from "react";

function Footer() {

  return (
    <Container height="40px" bgcolor="#2c272e"  >
      <hr />
      <Box fontFamily="sans-serif"  display="flex" justifyContent="space-around" pt="3rem" bgcolor="#021236" color="#fff" flexWrap="wrap" alignItems="center" >
        <Box>
          <h5>Featured Brands</h5>
          <h6>Heimat</h6>
          <h6>it Vanishes</h6>
          <h6>Lady White Co.</h6>
          <h6>Kestin</h6>
          <h6>Nanamica</h6>
          <h6>orSlow</h6>
          <h6>RoToTo</h6>
        </Box>
        <Box>
          <h5>Brands Info</h5>
          <h6>Heimat</h6>
          <h6>it Vanishes</h6>
          <h6>Lady White Co.</h6>
          <h6>Kestin</h6>
          <h6>Nanamica</h6>
          <h6>orSlow</h6>
          <h6>RoToTo</h6>
        </Box>
        <Box>
          <h5>Shop</h5>
          <h6>Heimat</h6>
          <h6>it Vanishes</h6>
          <h6>Lady White Co.</h6>
          <h6>Kestin</h6>
          <h6>Nanamica</h6>
          <h6>orSlow</h6>
          <h6>RoToTo</h6>
        </Box>
        <Box>
          <h5>Stay in the loop</h5>
          <h6>Heimat</h6>
          <h6>it Vanishes</h6>
          <h6>Lady White Co.</h6>
          <h6>Kestin</h6>
          <h6>Nanamica</h6>
          <h6>orSlow</h6>
          <h6>RoToTo</h6>
        </Box>
        <Box>
          <h5>Featured Brands</h5>
          <h6>Heimat</h6>
          <h6>it Vanishes</h6>
          <h6>Lady White Co.</h6>
          <h6>Kestin</h6>
          <h6>Nanamica</h6>
          <h6>orSlow</h6>
          <h6>RoToTo</h6>
        </Box>
        <Box>
          <h5>Featured Brands</h5>
          <h6>Heimat</h6>
          <h6>it Vanishes</h6>
          <h6>Lady White Co.</h6>
          <h6>Kestin</h6>
          <h6>Nanamica</h6>
          <h6>orSlow</h6>
          <h6>RoToTo</h6>
        </Box>
      </Box>
      <div>
        <img
          src="https://img.icons8.com/fluency/48/000000/instagram-new.png"
          alt="insta"
        />
        <img
          src="https://img.icons8.com/color/48/000000/facebook.png"
          alt="facebook"
        />
        <img
          src="https://img.icons8.com/material/48/000000/github.png"
          alt="git"
        />
        <img
          src="https://img.icons8.com/fluency/48/000000/twitter.png"
          alt="twitter"
        />
      </div>
    </Container>
  );
}

export default Footer;